import React, { useState, useEffect } from 'react'
import { Link, useParams  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';
import Loader from "react-js-loader";
import DynamicQuestions from './DynamicQuestions';

import DynamicOptions from './DynamicOptions';
function Editindustry(){
    const apiUrl = API_URL;
    const [items, setItems]=useState('');
    const [industryName, setIndustryName]=useState('');
    const getParam = useParams();
    const getindustryid = getParam.industryid;
    const [successMessages, setSuccessMessages] = useState([]);
    const [isLoading, setIsloading] = useState(false);
    const [questions, setQuestions] = useState([]);
    const [options, setOptions] = useState([]);
    const [id, setId] = useState(0);
    const [image, setImage] = useState({});
    const [is_image, setIsImage] = useState({});
        const getindustry = async (e) => {
            try{
                setIsloading(true)
                const postData = {
                    industry_id: getindustryid
                };
                // const formData = new FormData();
                // formData.append('industry_name', industry);
                // formData.append('image', image);
                
                const result = await fetch(`${apiUrl}/admin/viewindustry`,{
                    method: "POST",
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                    body:JSON.stringify(postData)
                });
                const data = await result.json();
                if(data.status !== 200){
                    throw new Error('Data not found');
                }
                else {
                    // console.log(data.data);
                    setItems(data.data);
                    setIndustryName(data.data.industryname[0])
                    setQuestions(data.data.questions);
                    setOptions(data.data.options);
                    setIsloading(false)
                }
            }
            catch(error){
                console.error('Error ', error)
            }
        };

    useEffect(()=>{
        getindustry();
    }, []);

    const updateindustry = async(e) =>{
        e.preventDefault();
        try{
            console.log(industryName);
            // return
            // const postData={
            //     id:getindustryid,
            //     industry_name:items.industryname[0]
            // }
            const formData = new FormData();
            formData.append('id', getindustryid);
            formData.append('industry_name', industryName);
            // formData.append("is_image", is_image);
            // formData.append('image', image);
                
            const result = await fetch(`${apiUrl}/editindustry`,{
                method: "POST",
                // headers:{
                //     "Content-Type":"application/json",
                //     "Accept":"application/json"
                // },
                body:formData // JSON.stringify(postData) 
            });
            const data = await result.json();
            if((data.status === 200)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }else if((data.status === 400)){
                const newSuccessMessage = data.message;
                setSuccessMessages([...successMessages, newSuccessMessage]);
            }
            if(data.status !== 200){
                throw new Error('Data not found');
            }
            setItems(data.data);
        }
        catch(error){
            console.log('Error: ', error)
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        setIsloading(true)
        getindustry();
        setIsloading(false)
        // window.location.reload();
    }
    // console.log(questions)
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Edit Industry</h2>
            {isLoading ? <Loader type="spinner-cub" title={"loading....."} size={100} />:
            <div className='commonCntr'>
                <div className="form-horizontal">
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="industryname">Industry Name:</label>
                        <div className="col-sm-4">
                            <input type="text" className="form-control" id="industryname" value={industryName} onChange={(e)=>setIndustryName(e.target.value)}  />
                        </div>
                    </div>
                    {/* <div className="form-group"> */}
                    {/* <h3>Upload image</h3> */}
                    {/* <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => {
                            setImage(e.target.files[0]);
                            setIsImage(true);
                          }}
                    /> */}
                    {/* </div> */}
                    {/* <div className="form-group">
                        <label className="control-label col-sm-8 label" htmlFor="industryname">Add options for the role:</label>
                        <div className="row">
                            <div className="col-sm-3">
                                <button onClick={addInput}>Add more questions</button>                    
                            </div>
                            <div className="col-sm-8">
                            {arr.map((item, i) => {
                                return (
                                <>
                                    <input
                                        onChange={handleChange}
                                        value={item.option}
                                        id={i}
                                        type={item.type}
                                        size="40"
                                    />
                                    <button onClick={() => removeInput(item, i)}>Add options to this questions</button>
                                    <button onClick={() => removeInput(item, i)}>Remove question</button>
                                </>
                                );
                            })}
                            </div>
                        </div>
                    </div> */}
                    {/* <DynamicQuestions industry_id={getindustryid} questionsList={questions}/> */}

                    <DynamicOptions industry_id={getindustryid} questionsList={options}/>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn" onClick={updateindustry}>Submit</button>
                        </div>
                    </div>
                </div>
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )}
            </div>}
        </div>
    )
}

export default Editindustry;